exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vac-message-container {\n  max-width: 100%;\n}\n.vac-message-wrapper .vac-offset-current {\n  margin-left: 0;\n}\n.vac-message-wrapper .vac-message-box {\n  max-width: none;\n}\n", ""]);

// exports
